module.exports = __webpack_public_path__ + "assets/pdf/privacy-policy.4b6e62b0.pdf";